var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector72(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 330,
    viewBox: "0 0 86 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-221.31 328.065C-202.395 304.676 -198.276 300.97 -178.867 286.154C-174.112 282.524 -164.868 276.812 -153.45 271.357C-150.034 269.722 -146.646 268.24 -143.305 266.881C-119.397 257.187 -92.6144 255.818 -66.1635 258.071C1.32554 263.82 62.2375 227.289 79.9948 171.978C97.7806 116.571 68.5204 55.0451 22.8602 25.0232C16.9189 21.1172 -11.1169 3.88718 -41.8766 1.34021C-138.996 -6.72836 -177.804 87.3479 -207.187 230.491C-207.757 233.276 -209.93 246.533 -210.319 249.346L-221.319 328.074L-221.31 328.065Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector72);
export default __webpack_public_path__ + "static/media/vector7-2.b60a2f74b91f2d50cbbcee2ce7d54994.svg";
export { ForwardRef as ReactComponent };